export default __webpack_public_path__ + "static/client-6-2d80ef4551b418a337ac00d22e345552.webp";